import UnlockLocationContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/UnlockLocationContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import FeedbackEvent from "../../feedback/event/FeedbackEvent";
import KeyDecisionSummaryEvent from "../../key-decision-summary/event/KeyDecisionSummaryEvent";
import BriefingEvent from "../event/BriefingEvent";

export default class CustomScreenCommand extends AbstractCommand {
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {UnlockLocationContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        var screen = this._content.getLocationID();

        // TODO: Make it even more generic later on
        if(screen == CustomScreenCommand.BRIEFING_SCREEN) {
            this._dispatcher.addEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBriefing.bind(this));

            this._briefingScreenSkin = this.openScreen(SkinKeyRegistry.BRIEFING_SCREEN_SKIN, {
                animationType: AnimationFactory.FADE_IN,
                animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
            }, {
                content: this._content,
            });
        } else if (screen == CustomScreenCommand.FEEDBACK_SCREEN) {
            this._dispatcher.addEventListener(FeedbackEvent.CLOSE_SCREEN_REQUEST, this._handleCloseFeedback.bind(this));

            this._feedbackScreenSkin = this.openScreen(SkinKeyRegistry.FEEDBACK_SCREEN_SKIN, {
                animationType: AnimationFactory.FADE_IN,
                animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
            }, {
                content: this._content,
            });
        } else if (screen == CustomScreenCommand.KEY_DECISION_SUMMARY) {
            this._dispatcher.addEventListener(KeyDecisionSummaryEvent.CLOSE_REQUEST, this._handleCloseKeyDecisionSummary.bind(this));

            this._keyDecisionSummaryScreenSkin = this.openScreen(SkinKeyRegistry.KEY_DECISION_SUMMARY_SCREEN_SKIN, {
                animationType: AnimationFactory.FADE_IN,
                animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
            }, {
                content: this._content,
            });
        }
    }

    _handleCloseBriefing() {
        this._dispatcher.removeEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBriefing.bind(this));

        this.closeScreen(this._briefingScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }

    _handleCloseFeedback() {
        this._dispatcher.removeEventListener(FeedbackEvent.CLOSE_SCREEN_REQUEST, this._handleCloseFeedback.bind(this));

        this.closeScreen(this._feedbackScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }

    _handleCloseKeyDecisionSummary() {
        this._dispatcher.removeEventListener(KeyDecisionSummaryEvent.CLOSE_REQUEST, this._handleCloseFeedback.bind(this));

        this.closeScreen(this._keyDecisionSummaryScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }
}

CustomScreenCommand.BRIEFING_SCREEN = "briefing";
CustomScreenCommand.FEEDBACK_SCREEN = "feedback";
CustomScreenCommand.KEY_DECISION_SUMMARY = "kd-summary";